import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Container from '@mui/material/Container';
import { SectionHeading } from './section_blocks';
import Typography from './modules/components/typography';
import withRoot from './with_root';

const ImageBackdrop = styled('div')(({ theme }) => ({
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  background: '#000',
  opacity: 0.45,
  transition: theme.transitions.create('opacity')
}));

const ImageIconButton = styled(ButtonBase)(({ theme }) => ({
  position: 'relative',
  display: 'block',
  padding: 0,
  borderRadius: 0,
  height: '42vh',
  [theme.breakpoints.down('md')]: {
    width: '100% !important',
    height: 120
  },
  '&:hover': { zIndex: 1 },
  '&:hover .imageBackdrop': { opacity: 0.1 },
  '&:hover .imageMarked': { opacity: 0 },
  '&:hover .imageTitle': { border: '4px solid currentColor' },
  '& .imageTitle': { position: 'relative', padding: `${theme.spacing(2)} ${theme.spacing(4)} 14px` },
  '& .imageMarked': {
    height: 3,
    width: 18,
    background: theme.palette.common.white,
    position: 'absolute',
    bottom: -2,
    left: 'calc(50% - 9px)',
    transition: theme.transitions.create('opacity')
  }
}));

const images = [
  {
    image_url:
      'https://images.pexels.com/photos/7821719/pexels-photo-7821719.jpeg?auto=compress&cs=tinysrgb&w=1000',
    title: 'Compound interest',
    width: '33%',
    url: '/compound-interest'
  },
  {
    image_url:
      'https://images.pexels.com/photos/4386372/pexels-photo-4386372.jpeg?auto=compress&cs=tinysrgb&w=1000',
    title: 'Emergency fund',
    width: '33%',
    url: '/emergency-fund/'
  },
  {
    image_url:
      'https://images.pexels.com/photos/5833790/pexels-photo-5833790.jpeg?auto=compress&cs=tinysrgb&w=1000',
    title: 'Learning hub',
    width: '33%',
    url: '/learning-hub/'
  }
];

function ProductCategories() {
  return (
    <Container component="section" sx={{ mt: 10, mb: 6 }}>
      <SectionHeading
        eyebrow="Toolkit"
        title="Choose your next money move"
        subtitle="Every calculator and guide is organized for quick, practical decision-making."
      />
      <Box sx={{ mt: 4, display: 'flex', flexWrap: 'wrap' }}>
        {images.map((image) => (
          <ImageIconButton key={image.title} href={image.url} style={{ width: image.width }}>
            <Box
              sx={{
                position: 'absolute',
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                backgroundSize: 'cover',
                backgroundPosition: 'center 40%',
                backgroundImage: `url(${image.image_url})`
              }}
            />
            <ImageBackdrop className="imageBackdrop" />
            <Box
              sx={{
                position: 'absolute',
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'common.white'
              }}
            >
              <Typography component="h3" variant="h6" color="inherit" className="imageTitle">
                {image.title}
                <div className="imageMarked" />
              </Typography>
            </Box>
          </ImageIconButton>
        ))}
      </Box>
    </Container>
  );
}

export default withRoot(ProductCategories);
